import React, { Component } from "react";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import { withAlert } from "react-alert";
import Widget from "./components/Widget";
import DateWidget from "./components/DateWidget";
import Banner from "./components/Banner";
import AccessionWidget from "./components/AccessionWidget";
import UserStore from "../../utils/UserStore";
import SettingsService from "../../services/SettingsService";

class AccessionPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      homeText: null
    };
  }

  componentDidMount() {
    const { setTitle } = this.props;
    setTitle("Home");

    this.getHomeText();
  }

  getHomeText = async () => {
    const homeText = await SettingsService.getHomeText();
    if (homeText) {
      this.setState({ homeText });
    }
  };

  clickDetails = type => {
    const { history } = this.props;
    history.push(`/accession-panel/${type}`);
  };

  render() {
    const { homeText } = this.state;

    return (
      <Grid container spacing={2}>
        <DateWidget sm={3} />
        <Widget sm={9}>
          <Banner
            userName={UserStore.getUserName().split(" ")[0]}
            homeText={homeText}
          />
        </Widget>

        <AccessionWidget
          sm={6}
          label="Lista de Responsáveis"
          onClick={() => this.clickDetails("responsibles")}
        />

        <AccessionWidget
          sm={6}
          label="Lista de Alunos"
          onClick={() => this.clickDetails("students")}
        />
      </Grid>
    );
  }
}

AccessionPanel.propTypes = {
  setTitle: PropTypes.func.isRequired,
  alert: PropTypes.shape({
    show: PropTypes.func
  }).isRequired, // inject by withAlert
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired // inject by withRouter
};

export default withAlert()(withRouter(AccessionPanel));
